var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"btn",staticClass:"btn flex items-center justify-center cursor-pointer",attrs:{"data-clipboard-text":_vm.copyTxt}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.$t('lang.components.copy'))+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }